<template lang='pug'>
  v-layout(row justify-end)
    v-dialog(v-model='dialog' persistent scrollable max-heigth="400px" max-width='900px')
      template(v-slot:activator='{ on }')
        div(class="text-xs-right" style="float: right;" )
          v-btn(color='success' dark v-on='on' style="width: 100%;") Novo Filtro
      v-card
        v-card-title
          span.headline Filtros
        v-card-text
          v-container(grid-list-lg)
            CustomerFilters
        v-card-actions
          v-spacer
          v-btn(color='red' dark @click='closeModal') Fechar
          v-btn(color='success' dark @click='onSubmit') Filtrar

</template>

<script>

export default {
  name: 'modal',

  components: {
    CustomerFilters: () => import('./CustomerFilters')
  },

  data() {
    return {
      loading: false,
      dialog: false,
      items: []
    }
  },

  created() {
    this.$root.$on('loading', this.setLoading)
    this.$root.$on('dialog', this.setDialog)
  },

  methods: {
    onSubmit() {
      this.$root.$emit('search')
    },

    closeModal() {
      this.dialog = false
      this.$root.$emit('closeModal')
    },

    setLoading(val) {
      this.loading = val
    },

    setDialog(val) {
      this.dialog = val
    }
  }
}
</script>

<style>
</style>
